/**
 * Module-gating constants for purchasing.
 *
 * Mirrors ``backend/procurement/modules.py``. Purchasing (vendors, purchase
 * orders, requisition → PO conversion) lives in the bidding-and-invoicing
 * module, which is currently the ``projects`` key (branded H3Books). When
 * books is split from project tracking, purchasing moves by changing
 * ``PURCHASING_MODULE_KEY`` here and in the backend module — nothing else in
 * the purchasing UI should hardcode the key.
 *
 * Requisitions are raised by site supervisors looking at a gear shortfall, so
 * they are reachable with H3Gear (``inventory``) *or* purchasing enabled.
 */
export const PURCHASING_MODULE_KEY = 'projects';

export const REQUISITION_MODULE_KEYS: string[] = ['inventory', PURCHASING_MODULE_KEY];
